/**
 * World Drop cards pushed by the server (apps/server/src/worldDrop.ts): a
 * rare drop anyone on the server just looted live.
 */
export interface WorldDropView {
  id: number;
  character: string;
  itemId: number;
  itemName: string;
  count: number;
  monsterId: string;
  monsterName: string;
  boss: boolean;
  at: number;
}

const listeners = new Set<(drop: WorldDropView) => void>();

export function pushWorldDrop(drop: WorldDropView): void {
  for (const listener of listeners) listener(drop);
}

export function subscribeWorldDrops(listener: (drop: WorldDropView) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
